import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';


const MyMapModal = ({ mapa, latitude,longitude,disabled}) => {
  // Estado para controlar a visibilidade do modal
  let key = process.env.REACT_APP_GOOGLE_KEY
  

  // Estado para armazenar a URL do Google Maps
  const [mapsUrl, setMapsUrl] = useState('');


  useEffect(() => {
    // Função para abrir o modal e gerar a URL do Google Maps quando mapa.value.latitude e mapa.value.longitude forem definidos
    if (mapa.value.latitude && mapa.value.longitude){
      const googleMapsUrl = `https://www.google.com/maps/embed/v1/place?q=${mapa.value.latitude},${mapa.value.longitude}&key=${key}&zoom=18`
      setMapsUrl(googleMapsUrl);
    }
      

  },[mapa.value])
  
  // Função para fechar o modal
  const closeModal = () => {
    mapa.set({open: false, latitude:null, longitude:null});
    setMapsUrl('');  // Limpa o URL para evitar problemas ao fechar
  };

  return (
    <Box>
      {/* Botão para abrir o modal */}
      {/* Modal */}
      {mapa.value.open && (
        <Box style={modalStyle} onClick={closeModal}>
          <Box style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
            <span onClick={closeModal} style={closeButtonStyle}>&times;</span>
            <iframe
              width="800"
              title="Google Maps"
              height="600"
              style={iframeStyle}
              loading="lazy"
              allowfullscreen
              referrerpolicy="no-referrer-when-downgrade"
              src={mapsUrl}>
            </iframe>            
          </Box>
        </Box>
      )}
    </Box>
  );
};
// Estilos em linha para o modal
const modalStyle = {
  display: 'flex',
  position: 'fixed',
  zIndex: 1,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  overflow: 'auto',
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  justifyContent: 'center',
  alignItems: 'center',
};

const modalContentStyle = {
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '5px',
  position: 'relative',
  maxWidth: '800px',
  width: '100%',
};

const closeButtonStyle = {
  position: 'absolute',
  top: '0px',
  right: '10px',
  fontSize: '50px',
  fontWeight: 'bold',
  cursor: 'pointer',
  color: '#aaa',
};

const iframeStyle = {
  width: '100%',
  height: '500px',
  border: 'none',
};


export default MyMapModal;
